module.exports = __webpack_public_path__ + "img/notice1.ccc92c6a.png";